/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { FlagType } from 'models/viewModels';
import { QtmThemeSetting } from 'theme';

export interface FlagColorObject {
  flag: number;
  fillHex: string;
  borderHex: string;
}

const unknownFlagColor = {
  flag: FlagType.UNKNOWNFLAGTYPE,
  fillHex: '#dddddd',
  borderHex: '#666666',
};

export const partialFlagColor = {
  flag: 1.5,
  fillHex: '#7cddec',
  borderHex: '#198ea0',
};

const flagColors: ReadonlyArray<FlagColorObject> = [
  {
    flag: FlagType.GREEN,
    fillHex: '#D3EDC8',
    borderHex: '#D3EDC8',
  },
  {
    flag: FlagType.YELLOW,
    fillHex: '#F9EBB6',
    borderHex: '#F9EBB6',
  },
  {
    flag: FlagType.RED,
    fillHex: '#F99698',
    borderHex: '#F99698',
  },
  {
    flag: FlagType.WHITE,
    fillHex: '#D9D9D6',
    borderHex: '#D9D9D6',
  },
  {
    flag: FlagType.CHECKER,
    fillHex: '#D3EDC8',
    borderHex: '#D3EDC8',
  },
  unknownFlagColor,
  partialFlagColor,
];

const flagColorsDark: ReadonlyArray<FlagColorObject> = [
  {
    flag: FlagType.GREEN,
    fillHex: '#6CC24A',
    borderHex: '#6CC24A',
  },
  {
    flag: FlagType.YELLOW,
    fillHex: '#F4D459',
    borderHex: '#F4D459',
  },
  {
    flag: FlagType.RED,
    fillHex: '#FA6E71',
    borderHex: '#FA6E71',
  },
  {
    flag: FlagType.WHITE,
    fillHex: '#ffffff',
    borderHex: '#ffffff',
  },
  {
    flag: FlagType.CHECKER,
    fillHex: '#6CC24A',
    borderHex: '#6CC24A',
  },
  unknownFlagColor,
  partialFlagColor,
];

export const getFlagColor = (flagType: number, colorMode?: QtmThemeSetting) => {
  const allFlagsColors = colorMode === 'light' ? flagColors : flagColorsDark;
  const flag = allFlagsColors.find((flagColor) => flagColor.flag === flagType);
  return flag || unknownFlagColor;
};

export const getFlagColorFromString = (flagType: string, colorMode?: QtmThemeSetting) => {
  const allFlagsColors = colorMode === 'light' ? flagColors : flagColorsDark;
  const flag = allFlagsColors.find((flagColor) => flagType.toUpperCase().includes(FlagType[flagColor.flag]));
  return flag || unknownFlagColor;
};
